import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import { ChevronRightIcon } from '@heroicons/react/20/solid';
import AlltaLogo  from '../../assets/logo/allta.png';
import AlltaInfo  from '../../assets/logo/allta_intro.png';
import CompanyMap from '../../assets/map/company_map.png';

export interface ListingExperiencesPageProps {
  className?: string;
}



const Security: any = ({}) => {
	const [content, setContent] = useState('');
  
	useEffect(() => {
	  const loadContent = async () => {
		try {
		  const response = `# 개인정보 보안 정책

[개인정보 처리방침]

제 1조. 개인정보 처리 방침의 의의
주식회사 올타(이하 회사)는 회사에서 제공하는 모든 서비스의 기획, 운영, 종료까지 정보통신망 이용 촉진 및 정보보호 등에 관한 법률(이하 '정보통신망법'), 대한민국 개인 정보보호법, 국내의 모든 개인 정보 보호 법령과 대한민국 행정안전부에서 권고하는 개인 정보 보호조치 가이드를 준수한다.

제 2조. 개인정보 수집 및 이용에 대한 동의
회사는 서비스 이용계약의 성립 및 이행에 필요한 최소한의 개인정보를 수집하며, 이용자 개인식별이 가능한 정보를 수집하기 위해 회원 가입 시 개인정보수집이용 동의에 대한 내용을 제공하고, 회원이 '회원가입' 버튼을 클릭 혹은 약관 동의 체크 후 다음 상태로 진행 시 개인정보수집이용에 대해 동의한 것으로 간주한다.

제 3조. 수집하는 개인정보 항목

1. 기본 개인정보
    - 회원의 이메일 주소
2. 변동 및 추가될 수 있는 개인정보
    - 회원의 이름
    - 회원의 전화번호
    - 회원의 성별
    - 회원의 주소
    - 회원의 소속
3. 서비스 이용과정에서 수집되는 정보
    - 아이디, 쿠키, 접속 IP정보
    - MAC 주소, 방문일시
    - 서비스 이용 기록
    - 불량 이용 기록
    - 브라우저 정보
    - 휴대폰 기기 모델명
    - 휴대폰 기기별 고유번호(UUID, UDID)
    - OS 정보
    - 광고 식별자(ADID, IDFA)
    - 휴대폰 제조사
    - 서비스 관련 상담, 민원 처리 기록

제 4조. 개인정보 수집방법

- 회원 가입 시 이용자의 자발적인 정보 입력
- 기타 회원의 자발적 제공을 통한 수집
- 생성정보 수집 툴을 통한 수집

제 5조. 개인정보 수집목적

1. 회원관리
회원제 서비스 이용 및 제한적 본인 확인제에 따른 본인확인, 개인식별, 부정 이용방지와 비인가 사용방지, 가입의사 확인, 가입 및 가입횟수 제한, 추후 법정대리인 본인확인, 분쟁 조정을 위한 기록보존, 불만 처리 등 민원처리, 고지사항 전달
2. 신규 서비스 개발 및 마케팅광고 활용
신규 서비스 개발 및 맞춤 서비스 제공, 통계학적 특성에 따른 서비스 제공, 서비스의 유효성 확인, 이벤트 및 광고성 정보 제공 및 참여기회 제공, 접속빈도 파악, 회원의 서비스 이용에 대한 통계

제 6조. 개인정보의 자동수집 장치의 설치 및 운영에 관한 사항

- 회사는 서비스에 처음 가입할 때 또는 웹 서비스를 이용하는 과정에서 홈페이지 또는 프로그램 등을 통하여 회원의 휴대전화번호, 가입자의 성과 이름, 스마트폰 등 단말기 정보(OS버전 및 기기정보), 서비스 사용시 이메일, 비밀번호를 수집할 수 있다.
- 서비스 이용 과정에서 서비스 이용기록, 접속로그, 접속 IP 정보, 제재 및 이용정지 기록, 장애 관련 정보 등이 생성되어 수집될 수 있다.
- 회사는 쿠키(cookie)를 설치, 운용할 수 있으며, 회원은 쿠키 설치에 대한 선택권을 가지고 있다.

제 7조. Google Analytics

- Google Analytics는 쿠키를 사용하여 사용자의 웹사이트 이용 방식을 분석한다.
- Google은 법률에 의하여 요구되는 경우 제3자에게 정보를 제공할 수 있다.
- 회원은 서비스 이용 시 Google Analytics 정보 이용에 동의하게 된다.

제 8조. 개인정보의 공유 및 제공
회사는 회원의 동의가 있거나 다음의 경우에만 개인정보를 제3자에게 제공할 수 있다:

- 회원이 사전에 동의한 경우
- 서비스 제공에 따른 요금 정산을 위해 필요한 경우
- 법령에 근거한 수사, 재판 또는 행정 목적의 요구가 있는 경우
- 통계작성, 학술연구나 시장조사를 위해 특정 개인을 식별할 수 없는 형태로 가공하여 제공하는 경우
- 관련 법령에서 정한 절차에 따른 요청이 있는 경우

제 9조. 개인정보의 보관기간 및 이용기간

1. 보관 기간:
- 계약 또는 청약철회 등에 관한 기록: 5년
- 대금결제 및 재화 등의 공급에 관한 기록: 5년
- 소비자의 불만 또는 분쟁처리에 관한 기록: 3년
- 표시/광고에 관한 기록: 6개월
- 웹사이트 방문기록: 3개월
1. 파기 대상:
- 1년 이상 미접속 휴면계정
- 회원이 동의를 철회한 경우
- 수집 및 이용목적이 달성된 경우
1. 파기절차:
- 종이 출력물: 분쇄기로 분쇄하거나 소각
- 전자적 파일: 재사용 불가능한 기술적 방법으로 삭제

제 10조. 개인정보 보호 대책

1. 회원의 의무:
- 회원 개개인이 본인의 ID와 비밀번호를 적절하게 관리해야 함
- 개인의 실수나 인터넷의 위험성으로 인한 문제는 회원 책임
1. 회사의 보안 대책:
- 기술적 대책: 암호화, 백신 프로그램, 보안장치 운영
- 관리적 대책: 최소 인원으로 접근 권한 제한
- 물리적 보호: 서버 보안, 침입차단시스템 운영
- 정기적 점검: 분기별 최소 1회 보안 대책 점검

제 11조. 고지의 의무

- 개인정보처리방침 변경 시 홈페이지를 통해 고지
- 변경 관련 문의는 개인정보 관리 책임자나 고객센터를 통해 가능

제 12조. 개인정보보호책임자
개인정보보호 및 관리책임자:

- 성명: 하태영
- 이메일: [hello@](mailto:hello@undefined.gg)alltacompany.co.kr

제 13조. 권익침해 구제방법

1. 개인정보 침해신고센터 (한국인터넷진흥원):
- 홈페이지: [privacy.kisa.or.kr](http://privacy.kisa.or.kr/)
- 전화: (국번없이) 118
- 주소: 전남 나주시 진흥길 9, 3층
1. 개인정보 분쟁조정위원회:
- 홈페이지: [www.kopico.go.kr](http://www.kopico.go.kr/)
- 전화: 1833-6972
- 주소: 서울시 종로구 세종로 209
1. 기타 기관:
- 대검찰청 사이버수사과: 지역번호+1301
- 경찰청 사이버안전국: 182

부칙:

- 공고일: 2025년 02월 10일
- 시행일: 2025년 02월 10일
		  `;
		  setContent(response);
		} catch (error) {
		  console.error('Error loading markdown:', error);
		}
	  };
	  
	  loadContent();
	}, []);
  
	const renderMarkdown = (text: string) => {
	  const lines = text.split('\n');
	  
	  return lines.map((line, index) => {
		// Headers
		if (line.startsWith('# ')) {
		  return (
			<h1 key={index} className="text-4xl font-bold mt-8 mb-4">
			  {line.replace('# ', '')}
			</h1>
		  );
		}
		if (line.startsWith('### ')) {
		  return (
			<h3 key={index} className="text-2xl font-semibold mt-6 mb-3">
			  {line.replace('### ', '')}
			</h3>
		  );
		}
		
		// Empty lines
		if (line.trim() === '') {
		  return <div key={index} className="h-4" />;
		}
		
		// Regular paragraphs
		return (
		  <p key={index} className="text-gray-700 leading-relaxed mb-4">
			{line}
		  </p>
		);
	  });
	};
  
	return (
		<>
			<div className="max-w-4xl mx-auto p-6">
				<div className="bg-white rounded-lg shadow-sm p-8">
					<Link to={`/`}>
						<a
							className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
						>
							올타 홈 이동
						</a>
					</Link>
					<div className="prose max-w-none">
						{renderMarkdown(content)}
					</div>
				</div>
			</div>
		</>
	);
  };
  

  
  export default Security;
  